<template>
    <div class="title-section">
        <p>A PUBLICATION FROM BROAD INSTITUTE OF MIT AND HARVARD</p>
        <h5>Last updated January 18, 2021</h5>
        <h1>{{ title }}</h1>
    </div>
</template>

<script>
    export default {
        name: 'ArticleHeader',
        props: {
            title: {
                type: String,
                default: 'Hello world!'
            },
            subtitle: {
                type: String,
                default: 'This is a subheader.'
            }
        }
    }
</script>